/* eslint-disable default-case */
import store from '@/features/common/store';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { NotificationData } from '@/features/settings/types';
import { AvailableService, CarrierCodeType, InProgress } from '@/features/shipment/types';
import { isEnabledPref } from '.';
import { getIsFreight } from './createShipment';

const isFedexGround = (serviceLevel: string): boolean => {
  return serviceLevel === 'FedExGround';
};

const isCanadaPostCarrierCode = (carrierCode: keyof typeof CarrierCodeType): boolean => {
  return carrierCode === 'Canadapost';
};

const checkAdultSignatureRequired = (
  carrierCode: keyof typeof CarrierCodeType,
  inProgressData: InProgress | null,
): boolean => {
  if (!inProgressData) return false;

  if ((carrierCode === 'Purolator' && inProgressData.toAddress.countryCode !== 'CA')
    || (carrierCode === 'PTC')) {
    if (inProgressData.packages.length) {
      const packageWithAdultSignature = inProgressData.packages.find(
        (item) => item.signatureOptions === 'AdultSignatureRequired',
      );
      return !!packageWithAdultSignature;
    }
  }

  return false;
};

export const getResultsNotifications = (
  service: AvailableService,
  onSubmit: () => void,
): void => {
  const notificationSettings = store.getters.getNotificationPrefs;
  const inProgressData: InProgress | null = store.getters.getInProgress;
  const notificationData: Array<NotificationData> = [];

  const isFreightRequirements = getIsFreight(inProgressData?.packages || []);
  const isAdultSignatureRequired = checkAdultSignatureRequired(service.carrierCode, inProgressData);
  const isNextDayPickup = isFedexGround(service.selectedService);
  const isCanadaPostCode = isCanadaPostCarrierCode(service.carrierCode);

  if (isFreightRequirements && isEnabledPref(notificationSettings, 'FreightRequirements')) {
    notificationData.push({ name: 'FreightRequirements' });
  }

  if (isAdultSignatureRequired && isEnabledPref(notificationSettings, 'AdultSignatureNA')) {
    notificationData.push({ name: 'AdultSignatureNA' });
  }

  if (isNextDayPickup && isEnabledPref(notificationSettings, 'NextDayPickup')) {
    notificationData.push({ name: 'NextDayPickup' });
  }

  if (isCanadaPostCode && isEnabledPref(notificationSettings, 'CPCPickup')) {
    notificationData.push({ name: 'CPCPickup' });
  }

  if (isEnabledPref(notificationSettings, 'DeliveryTimeInfo')) {
    notificationData.push({ name: 'DeliveryTimeInfo' });
  }

  if (notificationData.length) {
    store.dispatch('showNotification', notificationData);
    eventBus.$once(eventNames.NOTIFICATION_SUBMIT, onSubmit);
  } else {
    onSubmit();
  }
};
